export type ToastType = 'success' | 'error' | 'info' | 'warning';

export type ToastPayload = {
    id?: string;
    type?: ToastType;
    title?: string;
    message: string;
    duration?: number;
};

type Listener = (payload: ToastPayload) => void;

const listeners = new Set<Listener>();

function emit(payload: ToastPayload) {
    listeners.forEach((listener) => listener(payload));
}

export const toastBus = {
    subscribe(listener: Listener) {
        listeners.add(listener);
        return () => { listeners.delete(listener); }
    },

    show(payload: ToastPayload) {
        emit(payload);
    },

    success(message: string, opts?: Omit<ToastPayload, 'message' | 'type'>) {
        emit({ type: 'success', message, ...opts });
    },

    error(message: string, opts?: Omit<ToastPayload, 'message' | 'type'>) {
        emit({ type: 'error', message, ...opts });
    },

    info(message: string, opts?: Omit<ToastPayload, 'message' | 'type'>) {
        emit({ type: 'info', message, ...opts });
    },

    warning(message: string, opts?: Omit<ToastPayload, 'message' | 'type'>) {
        emit({ type: 'warning', message, ...opts });
    },
};
